import { all, fork } from 'redux-saga/effects'

import saveOrgValueSuccess from './saveOrgValueSuccess'
import switchFormSaga from './switchFormSaga'

export default function* valuesFlow() {
  yield all([fork(saveOrgValueSuccess), fork(switchFormSaga)])
}
